export class ModaliteReunion {
    id: number;
    name: string;
}


